<template functional>
  <div style="align-content: center">
    <strong><translate-text keyTranslate="common_words.name" />:</strong>
    {{ props.row.responsable_name }} {{ props.row.responsable_last_name }}
    <br />
    <strong><translate-text keyTranslate="common_words.phone" />:</strong>
    {{ props.row.responsable_phone }}
    <br />
    <strong><translate-text keyTranslate="common_words.email" />:</strong>
    {{ props.row.responsable_email }}
    <br />
  </div>
</template>
<script>
export default {
  name: 'ResponsableInfo',
};
</script>
